import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ClientService } from '../../services/client-service';

interface DriverFeedbackData {
    rating: number;
    comment?: string;
   
}

@Component({
    selector: 'app-driver-reviews',
    standalone: true,
    imports: [CommonModule, FormsModule, TranslatePipe],
    templateUrl: './driver-reviews.component.html',
    styleUrls: ['./driver-reviews.component.scss']
})
export class DriverReviewsComponent implements OnInit {
    @Input() driverInfo: { 
        driverFullName?: string; 
        driverAvgRatings?: number; 
        driverPlate?: string; 
        driverCarPlateNumber?: string;
        driverCarModel: string;
        driverPhoto?: string;
    } = {
        driverFullName: '',
        driverCarModel: '',
        driverAvgRatings: 0,
        driverPlate: '',
        driverCarPlateNumber: '',
        driverPhoto: ''
    };
    @Output() driverFeedbackSubmitted = new EventEmitter<DriverFeedbackData>();
    
    selectedRating = 0;
    hoveredRating = 0;
    isSubmitting = false;
    comment = '';
    
    private translate = inject(TranslateService);
    
    constructor(private clientService:ClientService) { }
    
    ngOnInit(): void {
        this.loadReviews();
    }
    
    loadReviews(): void {
      
    }

    selectRating(rating: number): void {
        this.selectedRating = rating;
    }

    hoverRating(rating: number): void {
        this.hoveredRating = rating;
    }

    resetHover(): void {
        this.hoveredRating = 0;
    }

    isStarFilled(starIndex: number): boolean {
        const currentRating = this.hoveredRating || this.selectedRating;
        return starIndex <= currentRating;
    }

    submitDriverFeedback(): void {
        if (this.selectedRating === 0 || this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;
        
        const feedbackData: DriverFeedbackData = {
            rating: this.selectedRating,
            comment: this.comment.trim() || undefined,
           
        };

        // Émettre l'événement vers le composant parent
        this.driverFeedbackSubmitted.emit(feedbackData);
        
        // Simuler un petit délai pour l'UX
        setTimeout(() => {
            this.isSubmitting = false;
            // Reset selection after submission
            this.selectedRating = 0;
            this.comment = '';
            console.log('Driver feedback data emitted:', feedbackData);
            
        }, 500);
    }

    loadImage(imagePath: string): string {
        return this.clientService.loadProfile2(imagePath);
    }
}